import { HeaderNavigationMenuItemType } from "@hopper-b2b/hopper-utils";
import {
  Link,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  MenuItem,
} from "@mui/material";
import ArrowRight from "../../../assets/icons/arrow_right.svg?react";
import CancelForAnyReasonIcon from "../../../assets/icons/products/cancelForAnyReason.svg?react";
import CarrotCashIcon from "../../../assets/icons/products/carrotCash.svg?react";
import ChangeForAnyReasonIcon from "../../../assets/icons/products/changeforAnyReason.svg?react";
import FlightDisruptionGuaranteeIcon from "../../../assets/icons/products/flightDisruptionGuarantee.svg?react";
import LeaveForAnyReasonIcon from "../../../assets/icons/products/leaveForAnyReason.svg?react";
import PriceFreezeIcon from "../../../assets/icons/products/priceFreeze.svg?react";
import PricePredictionIcon from "../../../assets/icons/products/pricePrediction.svg?react";
import VipSupportIcon from "../../../assets/icons/products/vipSupport.svg?react";
import CarsIcon from "../../../assets/icons/travel/cars.svg?react";
import FlightsIcon from "../../../assets/icons/travel/flights.svg?react";
import HomesIcon from "../../../assets/icons/travel/homes.svg?react";
import HotelsIcon from "../../../assets/icons/travel/hotels.svg?react";
import styles from "./NavigationMenuItem.module.scss";

export const iconMap = {
  // Products
  carrotCash: CarrotCashIcon,
  pricePrediction: PricePredictionIcon,
  priceFreeze: PriceFreezeIcon,
  cancelForAnyReason: CancelForAnyReasonIcon,
  changeForAnyReason: ChangeForAnyReasonIcon,
  leaveForAnyReason: LeaveForAnyReasonIcon,
  flightDisruptionGuarantee: FlightDisruptionGuaranteeIcon,
  vipSupport: VipSupportIcon,
  // Travel Verticals
  flights: FlightsIcon,
  hotels: HotelsIcon,
  cars: CarsIcon,
  homes: HomesIcon,
};

export const NavigationMenuItem = ({
  text,
  icon,
  link,
}: HeaderNavigationMenuItemType) => {
  const IconComponent = icon && typeof icon === "string" ? iconMap[icon] : null;

  return (
    <MenuItem component={Link} href={link} color="textPrimary">
      {IconComponent && (
        <ListItemIcon color="primary">
          <IconComponent className={styles.icon} />
        </ListItemIcon>
      )}
      <ListItemText inset={!icon} primary={text} className={styles.text} />
      <ListItemSecondaryAction>
        <ArrowRight />
      </ListItemSecondaryAction>
    </MenuItem>
  );
};
